/* generated by pull.js */
const manifest = {
  "noTranslations": true,
  "name": "Seperate Rectangle tool and Rounded Rectangle tool",
  "description": "Adds a seperate Rounded Rectangle tool like in earlier versions of PenguinMod. Does not remove the rounding option from the current rectangle tool.",
  "credits": [
    {
      "name": "JeremyGamer13"
    }
  ],
  "userscripts": [
    {
      "url": "userscript.js"
    }
  ],
  "dynamicEnable": true,
  "dynamicDisable": true,
  "enabledByDefault": false,
  "tags": []
};
export default manifest;